import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  ListPolicySnapshotsByBookingIdsApplicationErrors,
  ListPolicySnapshotsByBookingIdsResponse,
  listPolicySnapshotsByBookingIds as universalListPolicySnapshotsByBookingIds,
} from './bookings-policy-snapshots-v1-booking-policy-snapshot-booking-policy-snapshots.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/bookings' };

export function listPolicySnapshotsByBookingIds(
  httpClient: HttpClient
): ListPolicySnapshotsByBookingIdsSignature {
  return (bookingIds: string[]) =>
    universalListPolicySnapshotsByBookingIds(
      bookingIds,
      // @ts-ignore
      { httpClient }
    );
}

interface ListPolicySnapshotsByBookingIdsSignature {
  /**
   * Retrieves a list of booking policy snapshots by [booking IDs](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/about-the-bookings-apis).
   * @param - List of booking IDs to retrieve policy snapshots for.
   */
  (bookingIds: string[]): Promise<
    NonNullablePaths<
      ListPolicySnapshotsByBookingIdsResponse,
      | `bookingPolicySnapshots`
      | `bookingPolicySnapshots.${number}.policy.customPolicyDescription.enabled`
      | `bookingPolicySnapshots.${number}.policy.customPolicyDescription.description`
      | `bookingPolicySnapshots.${number}.policy.cancellationPolicy.enabled`
      | `bookingPolicySnapshots.${number}.policy.cancellationPolicy.limitLatestCancellation`
      | `bookingPolicySnapshots.${number}.policy.cancellationPolicy.latestCancellationInMinutes`
      | `bookingPolicySnapshots.${number}.policy.reschedulePolicy.enabled`
      | `bookingPolicySnapshots.${number}.policy.reschedulePolicy.limitLatestReschedule`
      | `bookingPolicySnapshots.${number}.policy.reschedulePolicy.latestRescheduleInMinutes`
      | `bookingPolicySnapshots.${number}.policy.cancellationFeePolicy.enabled`
      | `bookingPolicySnapshots.${number}.policy.saveCreditCardPolicy.enabled`,
      6
    > & {
      __applicationErrorsType?: ListPolicySnapshotsByBookingIdsApplicationErrors;
    }
  >;
}

export {
  ActionEvent,
  BookingPolicy,
  BookingPolicySnapshot,
  CancellationFeePolicy,
  CancellationPolicy,
  CancellationWindow,
  CancellationWindowFeeOneOf,
  CompletionRequirement,
  DomainEvent,
  DomainEventBodyOneOf,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  IntakeFormPolicy,
  ListPolicySnapshotsByBookingIdsRequest,
  ListPolicySnapshotsByBookingIdsResponse,
  Money,
  PolicyDescription,
  ReschedulePolicy,
  RestoreInfo,
  SaveCreditCardPolicy,
  Timing,
} from './bookings-policy-snapshots-v1-booking-policy-snapshot-booking-policy-snapshots.universal.js';
